/**
 * Email Signup Block Component
 *
 * Handles dynamic padding adjustment for email signup input fields
 * when integrated buttons have variable widths.
 */
class EmailSignupBlock extends HTMLElement {
  constructor() {
    super();
    /** @type {number} */
    this.lastButtonWidth = 0;
    /** @type {ResizeObserver | undefined} */
    this.observer = undefined;

    this.adjustInputPadding = this.adjustInputPadding.bind(this);
    this.handleInvalid = this.handleInvalid.bind(this);
    this.handleInput = this.handleInput.bind(this);
  }

  connectedCallback() {
    this.button = this.querySelector('.email-signup__button--integrated');
    this.input = this.querySelector('.email-signup__input');
    this.inputGroup = this.querySelector('.email-signup__input-group');
    this.checkbox = this.querySelector('input[type="checkbox"]');

    const isTextButton = this.button && this.button.classList.contains('email-signup__button--text');

    if (this.button && this.input && this.inputGroup && isTextButton) {
      this.adjustInputPadding();

      this.observer = new ResizeObserver(() => {
        this.adjustInputPadding();
      });
      this.observer.observe(this.button);

      if ('fonts' in document) {
        document.fonts.ready.then(() => {
          this.adjustInputPadding();
        });
      }
    }

    // Setup custom validation messages
    if (this.input) {
      this.input.addEventListener('invalid', this.handleInvalid);
      this.input.addEventListener('input', this.handleInput);
    }

    if (this.checkbox) {
      this.checkbox.addEventListener('invalid', (e) => {
        e.target.setCustomValidity('Kérjük, fogadd el a feltételeket a folytatáshoz.');
      });
      this.checkbox.addEventListener('change', (e) => {
        e.target.setCustomValidity('');
      });
    }
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.input) {
      this.input.removeEventListener('invalid', this.handleInvalid);
      this.input.removeEventListener('input', this.handleInput);
    }
  }

  handleInvalid(e) {
    const input = e.target;
    
    if (input.validity.valueMissing) {
      input.setCustomValidity('Kérjük, add meg az e-mail címed.');
    } else if (input.validity.typeMismatch) {
      input.setCustomValidity('Kérjük, adj meg egy érvényes e-mail címet.');
    } else {
      input.setCustomValidity('Kérjük, adj meg egy érvényes e-mail címet.');
    }
  }

  handleInput(e) {
    e.target.setCustomValidity('');
  }

  adjustInputPadding() {
    if (!this.button || !this.inputGroup) return;

    const buttonWidth = /** @type {HTMLElement} */ (this.button).offsetWidth;

    if (buttonWidth !== this.lastButtonWidth) {
      this.lastButtonWidth = buttonWidth;
      /** @type {HTMLElement} */ (this.inputGroup).style.setProperty('--button-actual-width', `${buttonWidth}px`);
    }
  }
}

if (!customElements.get('email-signup-block')) {
  customElements.define('email-signup-block', EmailSignupBlock);
}